import { CompanyTypeSlug } from '../models/companies'

export const CHAINS_TABLE_KEY = 'all-chains-table'
export const DOORS_TABLE_KEY = 'all-doors-table'
export const DOORS_REPORTS_TABLE_KEY = 'doors-reports-table'
export const CHAINS_REPORTS_TABLE_KEY = 'chains-reports-table'
export const COLLEGE_AND_UNIVERSITY_TABLE_KEY = 'college-and-universities-table'
export const K12_TABLE_KEY = 'k-12-table'
// Unified opps/doors summary query keys (chains/doors stat cards). Mutations
// that change a chain/door's membership or LTV must invalidate these.
export const UNIFIED_CHAINS_SUMMARY_KEY = 'unified-chains-summary'
export const UNIFIED_DOORS_SUMMARY_KEY = 'unified-doors-reports-summary'
export const UGC_TABLE_KEY = 'ugc-table'
export const DEAL_TABLE_KEY = 'all-deals-table'
export const CONTACTS_TABLE_KEY = 'contacts-table'
// Single shared key for the company/door Contacts modal. Kept company-agnostic
// so the user's column layout (order/visibility) persists across companies and
// doors, rather than being siloed per company id (FIR-7301). Data scoping is
// handled separately via the forCompany / forDoorProxyId query params.
export const CONTACTS_MODAL_TABLE_KEY = 'contacts-modal'
// Surface the most relevant identity fields (name, title, seniority,
// department, company) before the long run of email columns. Without this the
// default order pushes Title far to the right, forcing horizontal scrolling
// (FIR-7301). Ids match the react-table column ids in useContactsTableColumns.
export const CONTACTS_MODAL_COLUMN_ORDER = [
  'full_name',
  'first_name',
  'last_name',
  'title',
  'seniority',
  'department',
  'contact_company',
  'email_preferred',
  'email_work',
  'email_personal',
  'email_generic',
]
export const CONTACT_REQUEST_JOB_TABLE_KEY = 'contact-requests-table'
export const HOSPITALS_TABLE_KEY = 'hospitals-table'
export const NURSING_HOMES_TABLE_KEY = 'nursing-homes-table'
export const LODGING_TABLE_KEY = 'lodging-table'
export const LODGING_DOOR_TABLE_KEY = 'lodging-door-table'
export const CONVENIENCE_TABLE_KEY = 'convenience-table'
export const CONVENIENCE_DOOR_TABLE_KEY = 'convenience-door-table'
export const ALL_CAMPAIGNS_TABLE_KEY = 'ALL_CAMPAIGNS_TABLE'
export const PRODUCTS_TABLE_KEY = 'products-table'
export const SAMPLES_TABLE_KEY = 'samples-table'
export const CONNECTIONS_TABLE_KEY = 'connections-table'
export const MOBILE_EVENTS_TABLE_KEY = 'mobile-events-table'

export const getCompanyTableKey = (slug: CompanyTypeSlug) =>
  `${slug}-company-table`
// Canonical suffix for campaign-scoped table query keys. Shared with the
// invalidation predicate in invalidateCampaignTargetQueries (FIR-7460).
export const getCampaignTableSuffix = (campaignID: number) =>
  `-campaign-${campaignID}`
export const getCampaignTableKey = (tableKey: string, campaignID: number) =>
  `${tableKey}${getCampaignTableSuffix(campaignID)}`
